import {remCalc} from '../../_utils'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

export default {
    baseStyle: () => {
        const hidePassword = getAssetUrl('static/img/form/hide-password.svg')
        const showPassword = getAssetUrl('static/img/form/show-password.svg')

        return {
            accountContainer: {
                w: '100%',
                paddingY: {base: remCalc(24), lg: remCalc(80)},
                paddingTop: {base: remCalc(0)},
                paddingInline: {base: remCalc(16), md: remCalc(24)},
                gap: {base: remCalc(24)},
            },
            accountTitle: {
                textStyle: {base: 'head-large', lg: 'head-xlarge'},
                marginTop: {base: remCalc(24), lg: remCalc(0)},
                paddingY: {base: remCalc(16), lg: remCalc(24)},
                fontWeight: 500,
                borderBottom: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                outline: 'none',
            },
            shippingSubtitle: {
                textStyle: {base: 'head-xsmall', lg: 'head-medium'},
                paddingY: remCalc(16),
                fontWeight: 500,
                borderStyle: 'solid',
                borderColor: 'border.light',
            },
            accountDetailContainer: {
                gap: {base: remCalc(24), sm: remCalc(24), lg: remCalc(40)},
            },
            accountDetailContent: {
                gap: {base: remCalc(24), lg: remCalc(40)},
            },
            ToggleCardContainer: {
                display: 'flex',
                flexDirection: 'column',
                maxWidth: '100%',
            },
            formTitle: {
                textStyle: {base: 'head-xsmall', lg: 'head-medium'},
                fontWeight: 500,
            },
            formMandatory: {
                textStyle: {base: 'body-small'},
            },
            fieldBox: {
                display: 'flex',
                textStyle: 'body-medium',
                gap: remCalc(4),
            },
            goBackButton: {
                textStyle: 'body-small',
                position: 'absolute',
                textAlign: 'left',
                zIndex: 10,
            },
            deleteButton: {
                textStyle: 'body-small',
                justifyContent: 'flex-start',
                width: '100%',
                fontWeight: 400,
                paddingTop: remCalc(24),
            },
            profileImage: {
                w: '100px',
                h: '100px',
                flexShrink: 0,
                borderRadius: 'large.base',
                display: {base: 'none', lg: 'block'},
                paddingInline: {base: remCalc(16), md: remCalc(24), xl: 0},
            },
            greetingsContainer: {
                padding: remCalc(16),
                alignItems: 'center',
                gap: remCalc(8),
                backgroundColor: 'background.brand',
                borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
            },
            initialsBox: {
                backgroundColor: 'background.default',
                borderRadius: '50%',
                boxSize: remCalc(52),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            },
            greetings: {
                textStyle: 'body-small',
                color: 'text.inverse',
            },
            name: {
                textStyle: 'body-small',
                color: 'text.inverse',
                fontWeight: 700,
            },
            initials: {
                textStyle: 'body-large',
                color: 'text.default',
            },
            accountSideBar: {
                display: {base: 'none', lg: 'flex'},
                gap: remCalc(16),
            },
            personalInformationTitle: {
                textStyle: 'body-large',
                color: 'text.default',
                fontWeight: 700,
            },
            sideBarLink: {
                textStyle: 'body-medium',
                color: 'text.default',
                fontWeight: 400,
            },
            sideBarSection: {
                padding: `${remCalc(24)} ${remCalc(16)}`,
                alignItems: 'flex-start',
                gap: remCalc(24),
                backgroundColor: 'background.light',
                borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
            },
            accordionSideBarSection: {
                borderRadius: 0,
                backgroundColor: 'background.light',
                color: 'text.default',
                paddingBottom: remCalc(24),
                gap: remCalc(16),
            },
            accordionInformationTitle: {
                textStyle: 'body-large',
                color: 'text.default',
                fontWeight: 400,
            },
            guestRegisteredProductContainer: {
                gap: 0,
                w: '100%',
                maxW: remCalc(1400),
                margin: 'auto',
                padding: {base: remCalc(20), lg: remCalc(40)},
            },
            accordionLink: {
                textStyle: 'body-medium',
                color: 'text.default',
                fontWeight: 400,
            },
            accountAccordionPanel: {
                paddingInline: 0,
                color: 'text.default',
                background: 'background.light',
                marginTop: 0,
                padding: remCalc(24),
                border: 'none',
                borderRadius: `0px 0px medium.base medium.base`,
            },
            accordionGap: {
                gap: remCalc(16),
            },
            sideBarGap: {
                gap: remCalc(16),
            },
            accountAccordion: {
                overflow: 'hidden',
                alignItems: 'center',
                borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
                color: 'text.default',
                paddingY: remCalc(8),
            },
            accountAccordionButton: {
                padding: remCalc(16),
                textStyle: 'body-small',
                fontWeight: '700',
                color: 'text.inverse',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: 'background.brand',
                borderRadius: 'medium.base',
            },
            accountAccordionButtonText: {textStyle: 'body-small', fontWeight: '700'},
            accountAccordionItem: {
                p: 0,
                minHeight: remCalc(40),
                border: 'none',
                backgroundColor: 'background.brand',
                color: 'text.inverse',
                borderRadius: 'medium.base',
            },
            naming: {
                gap: remCalc(4),
            },
            headingTitle: {
                textStyle: {base: 'head-large', lg: 'head-xlarge'},
                borderBottom: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                paddingY: {base: remCalc(16), lg: remCalc(24)},
                fontWeight: 500,
            },
            description: {
                textStyle: 'body-medium',
            },
            moreBenefits: {
                textStyle: 'body-large',
            },
            productRegistrationBox: {
                flexDirection: 'column',
                padding: remCalc(24),
                border: 'small',
                borderColor: 'border.light',
                borderRadius: 'base',
                gap: remCalc(40),
            },
            cardGrid: {
                columns: {
                    lg: 2,
                    md: 2,
                    sm: 1,
                    base: 1,
                },
                rowGap: {base: remCalc(16), lg: remCalc(24)},
                columnGap: {base: remCalc(16), lg: remCalc(40)},
            },
            registerButton: {
                maxW: {base: '100%', lg: remCalc(332)},
            },
            registeredProductBox: {
                paddingY: {base: remCalc(16), lg: remCalc(24)},
                borderBottom: 'small',
                borderColor: 'border.light',
            },
            registeredProductImage: {
                width: {
                    lg: remCalc(177),
                    md: remCalc(109),
                    sm: remCalc(109),
                    base: remCalc(109),
                },
                height: {
                    lg: remCalc(177),
                    md: remCalc(109),
                    sm: remCalc(109),
                    base: remCalc(109),
                },
            },
            registredProductNameContainer: {
                gap: remCalc(8),
                justifyContent: 'space-between',
            },
            registeredProductName: {
                textStyle: 'head-xsmall',
                fontWeight: 500,
                wordWrap: 'break-word',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                maxWidth: {base: remCalc(184), sm: 'initial'},
            },
            registeredProductDeleteIcon: {
                w: remCalc(16),
                h: remCalc(16),
            },
            registeredProductPurchased: {
                textStyle: 'body-xsmall',
                gap: remCalc(4),
            },
            registeredProductRegistration: {
                textStyle: 'body-xsmall',
                gap: remCalc(4),
            },
            editRegisterProduct: {
                width: 'fit-content',
                textStyle: 'body-xsmall',
            },
            serviceButton: {
                fontSize: remCalc(12),
                lineHeight: remCalc(8),
                paddingY: remCalc(12),
                paddingX: remCalc(16),
                border: 'small',
                minWidth: remCalc(100),
            },
            'is-editing': {
                border: 'none',
                padding: 0,
            },
            '.dln-registration__subtitle': {
                textStyle: {base: 'head-small', sm: 'head-xsmall', md: 'head-small'},
                fontWeight: 500,
                color: 'text.default',
                marginBottom: {base: remCalc(8), sm: remCalc(16)},
            },
            '.dln-registration__paragraph': {
                textStyle: 'body-medium',
                color: 'text.default',
                marginBottom: {
                    base: remCalc(16),
                    sm: remCalc(24),
                    md: remCalc(16),
                    lg: remCalc(24),
                },
                textAlign: 'inherit !important',
            },
            '.dln-loginForm__paragraph': {
                textStyle: 'body-medium',
                color: 'text.default',
                marginBottom: {
                    base: remCalc(16),
                    sm: remCalc(24),
                    md: remCalc(16),
                    lg: remCalc(24),
                },
            },
            '.separator-wrapper': {
                height: remCalc(1),
                marginY: remCalc(30),
            },
            '.gigya-input-text': {
                borderRadius: '4px',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.dark',
                w: '100%',
                padding: `${remCalc(14)} ${remCalc(8)} ${remCalc(8)}`,
                textStyle: 'body-small',
            },
            '.gigya-input-password': {
                borderRadius: '4px',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.dark',
                w: '100% !important',
                padding: `${remCalc(14)} ${remCalc(8)} ${remCalc(8)}`,
                textStyle: 'body-small',
                background: 'none !important',
                transition: 'none',
                minWidth: '0px',
            },
            '.gigya-reset *, div.gigya-reset, .gigya-reset span, .gigya-reset a:hover, .gigya-reset a:visited, .gigya-reset a:link, .gigya-reset a:active':
                {
                    textStyle: 'body-small',
                },
            '.gigya-screen input[disabled], .gigya-screen input:disabled': {
                bg: 'transparent',
            },
            '.gigya-screen .gigya-composite-control-password-peek input': {
                marginLeft: '0 !important',
            },
            '.gigya-screen .gigya-composite-control-password-peek .gigya-show-password-button': {
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                background: 'transparent',
                padding: 0,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: remCalc(16),
                borderRadius: remCalc(4.5),
                marginRight: '8px',
            },
            '.gigya-screen .gigya-composite-control-password-peek input[type=password] + .gigya-show-password-button .gigya-password-icon, .gigya-screen .gigya-composite-control-password-peek[data-show-password=false] .gigya-password-icon':
                {
                    content: `url("${hidePassword}")`,
                    height: remCalc(24),
                    width: remCalc(24),
                    mr: remCalc(16),
                },
            '.gigya-screen .gigya-composite-control-password-peek input[type=text] + .gigya-show-password-button .gigya-password-icon, .gigya-screen .gigya-composite-control-password-peek[data-show-password=true] .gigya-password-icon':
                {
                    content: `url("${showPassword}")`,
                    height: remCalc(24),
                    width: remCalc(24),
                    mr: remCalc(16),
                },
            '.gigya-screen .gigya-composite-control-password-peek .gigya-error-msg.gigya-error-msg-active':
                {
                    marginTop: '0 !important',
                },
            '.gigya-screen .gigya-terms-error, .gigya-screen input.gigya-error, .gigya-screen input[type="text"].gigya-error, .gigya-screen input[type="password"].gigya-error, .gigya-screen input[type="email"].gigya-error, .gigya-screen select.gigya-error':
                {
                    padding: `${remCalc(14)} ${remCalc(8)} ${remCalc(8)}`,
                },
            '.focused-control, .gigya-screen .gigya-composite-control-password-peek .gigya-show-password-button:focus':
                {
                    border: '0 !important',
                    boxShadow: 'none',
                },
            '.dlg-gigya-input-text-wrapper': {
                lineHeight: '150%',
                display: 'inline-block',
                width: '100%',
                textAlign: 'left',
                transition: 'all .4s cubic-bezier(.25,.8,.25,1)',
                position: 'relative',
                marginBottom: remCalc(10),
            },
            '.gigya-composite-control-password': {
                position: 'relative',
            },
            '.gigya-composite-control-textbox': {
                position: 'relative',
            },
            '.gigya-label-text': {
                color: 'text.secondary',
                textStyle: 'body-small',
            },
            '.gigya-error-msg': {
                minHeight: remCalc(24),
                color: 'text.danger',
                textAlign: 'left',
            },
            '.gigya-forgotPassword': {
                textStyle: 'body-small',
                color: 'text.tertiary',
                float: {base: 'none', lg: 'right'},
                textAlign: {base: 'inherit', lg: 'right'},
                textDecoration: 'underline',
                zIndex: 1,
            },
            '.gigya-input-submit': {
                w: '100%',
                display: 'inline-flex',
                maxW: '100%',
                outlineWidth: 0,
                textStyle: 'body-medium',
                fontWeight: 'bold',
                alignItems: 'center',
                padding: `${remCalc(10)} ${remCalc(24)}`,
                maxHeight: remCalc(40),
                bg: 'button.background.primary-default',
                borderRadius: [
                    'button.radius.primary-default.base',
                    'button.radius.primary-default.sm',
                    'button.radius.primary-default.md',
                    'button.radius.primary-default.lg',
                ],
                '.gigya-style-modern div.gigya-screen-dialog-main': {
                    backgroundColor: 'background.default',
                    padding: remCalc(20),
                    maxwidth: remCalc(540),
                },
                '.gigya-style-modern div.gigya-screen-dialog-top': {
                    padding: 0,
                    border: 0,
                    lineHeight: 0,
                    backgroundColor: 'background.default',
                },
                color: 'button.text.primary-default',
                _hover: {
                    bg: 'button.background.primary-hover',
                },
                _focus: {
                    border: remCalc(2),
                    borderColor: 'button.border.primary-focused',
                    borderStyle: 'solid',
                    bg: 'button.background.primary-focused',
                },
                _disabled: {
                    bg: 'button.background.primary-disabled',
                    color: 'button.text.primary-disabled',
                    _hover: {
                        bg: 'button.background.primary-disabled !important',
                        color: 'button.text.primary-disabled',
                    },
                },
                _pressed: {
                    bg: 'button.background.primary-pressed',
                    color: 'button.text.primary-pressed',
                },
            },
            'gigya-profile-form': {
                marginBottom: remCalc(18),
            },
            '.dlg-gigya-button-wrapper': {
                width: '100%',
                margin: '0',
            },
            '.dlg-gigya-button-wrapper input[type=submit]': {
                margin: '0 auto',
            },
            '.dlg-gigya-button-wrapper input[type=button]': {
                bg: 'button.background.primary-default',
                color: 'button.text.primary-default',
            },
            '.dlg-gigya-button-wrapper input[type=button], .dlg-gigya-button-wrapper input[type=submit]':
                {
                    outline: 'none',
                    textStyle: 'body-medium',
                    textAlign: 'center',
                    fontWeight: 700,
                    boxShadow: 'none',
                    transition: 'all .3s linear',
                    WebkitAppearance: 'none',
                    MozAppearance: 'none',
                    cursor: 'pointer',
                    WebkitUserSelect: 'none',
                    userSelect: 'none',
                    height: '40px',
                    padding: '0',
                    textDecoration: 'none',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    borderRadius: [
                        'button.radius.primary-default.base',
                        'button.radius.primary-default.sm',
                        'button.radius.primary-default.md',
                        'button.radius.primary-default.lg',
                    ],
                    overflow: 'hidden',
                    width: '100%',
                    maxWidth: {base: '100%', lg: remCalc(332)},
                },
            '.gigya-password-input-container': {
                position: 'relative',
                width: '100%',
            },
            'ownid-fingerprint-button-widget': {
                zIndex: '2',
                '--ownid-button-widget-color': '#000',
                '--ownid-button-widget-border-color': '#000',
                opacity: '1',
                '--ownid-button-height': '39px',
                '--ownid-qr-or-width': '23px',
                top: '0px',
                left: '0px',
            },
            '.gigya-input-password.ownid-skip-password': {
                backgroundImage:
                    'url(\'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" fill="%23888888" viewBox="0 0 24 24"%3E%3Cpath d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 13c-3.15 0-5.87-1.93-7.06-4.5C6.13 10.93 8.85 9 12 9s5.87 1.93 7.06 4.5c-1.19 2.57-3.91 4.5-7.06 4.5zm0-6c-1.11 0-2 .89-2 2s.89 2 2 2 2-.89 2-2-.89-2-2-2z"%3E%3C/path%3E%3C/svg%3E\')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '16px 16px',
                backgroundPosition: 'right center',
                paddingRight: remCalc(30),
            },
            loginStack: {
                width: {base: '100%', md: '100%', lg: '50%', xl: '32%'},
                paddingInline: remCalc(0),
                paddingRight: {base: '0', lg: remCalc(12)},
            },
            registrationStack: {
                display: 'flex',
                width: {base: '100%', lg: 'calc(50% - 16px)', xl: 'calc(42% - 16px)'},
                marginTop: {base: remCalc(40), lg: 0},
                gap: 0,
            },
            registrationButtonLogin: {
                gap: '0',
                width: {base: '100%', md: '100%', lg: '50%'},
                paddingInline: remCalc(0),
                paddingLeft: {base: '0', lg: remCalc(12)},
                marginTop: {base: remCalc(16), md: '0'},
                paddingTop: {base: remCalc(16), md: '0'},
                borderTop: {base: 'small', sm: 'none', md: 'small'},
                borderStyle: {base: 'solid', sm: 'none', md: 'none'},
                borderColor: 'border.light',
            },
            registrationButtonStack: {
                w: {base: '100%', lg: '50%'},
            },
            registrationButton: {
                maxWidth: remCalc(332),
            },
            '.gigya-composite-control': {
                position: 'relative',
            },
            '.dlg-gigya-input-text-wrapper input': {
                borderRadius: '4px',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.dark',
                color: 'text.default',
                textStyle: 'body-xsmall',
                outline: '0',
                width: '100%',
                lineHeight: '16px',
                backgroundColor: 'transparent',
                padding: '14px 8px 8px',
                boxSizing: 'border-box',
                appearance: 'none',
            },
            '.dlg-gigya-input-text-wrapper input.gigya-error': {
                padding: '14px 8px 8px',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'text.danger',
            },
            '.dlg-gigya-input-text-wrapper .gigya-label': {
                lineHeight: '150%',
                display: 'inline-block',
                color: 'text.secondary',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                transformOrigin: '0 0',
                transition:
                    'top .4s cubic-bezier(.25,.8,.25,1), transform .4s cubic-bezier(.25,.8,.25,1), color .4s cubic-bezier(.25,.8,.25,1), width .4s cubic-bezier(.25,.8,.25,1)',
                padding: '0 4px',
                overflow: 'hidden',
                pointerEvents: 'none',
                position: 'absolute',
                top: 'calc(50% - 21px)',
                left: '8px',
                zIndex: '1',
                textStyle: 'body-xsmall',
            },
            '.dlg-gigya-input-text-wrapper .gigya-label.gigya-error': {
                color: 'text.danger !important',
            },
            '.dlg-gigya-input-text-wrapper.ownId-left .gigya-label:has(+ ownid-fingerprint-button-widget, + .gigya-password-input-container ownid-fingerprint-button-widget)':
                {
                    left: remCalc(80),
                },
            '.dlg-gigya-input-text-wrapper.focus-visible + .gigya-label': {
                backgroundColor: 'background.default',
                transform: 'translateY(calc(50% - 29px)) scale(.75)',
            },
            '.dlg-gigya-input-text-wrapper.focus-visible .gigya-label:first-of-type': {
                backgroundColor: 'background.default',
                transform: 'translateY(calc(50% - 29px)) scale(.75)',
            },
            '.gigya-composite-control-textbox:focus-within .gigya-label, .gigya-composite-control-textbox .gigya-label:has(~ .gigya-valid, ~ .gigya-error, ~ input[type=date]), [data-screenset-element-id=gigya-complete-registration-screen] .gigya-composite-control-textbox .gigya-label:has(~ input[name="profile.email"])':
                {
                    transform: 'translateY(calc(50% - 29px)) scale(0.75)',
                    backgroundColor: 'background.default',
                    color: 'border.dark',
                    fontSize: 'inherit',
                },
            '.gigya-composite-control-textbox .gigya-label:has(~ .gigya-error), .gigya-composite-control-textbox .gigya-label:has(~ .gigya-error) *':
                {
                    color: 'text.danger',
                },
            '.gigya-composite-control-password:focus-within .gigya-label, .gigya-composite-control-password .gigya-label:has(~ .gigya-valid, ~ .gigya-error, ~ .gigya-password-input-container .gigya-valid, ~ .gigya-password-input-container .gigya-error)':
                {
                    transform: 'translateY(calc(50% - 29px)) scale(0.75)',
                    backgroundColor: 'background.default',
                    color: 'border.dark',
                    fontSize: 'inherit',
                },
            '.gigya-composite-control-password .gigya-label:has(~ .gigya-error, ~ .gigya-password-input-container .gigya-error), .gigya-composite-control-password .gigya-label:has(~ .gigya-error, ~ .gigya-password-input-container .gigya-error) *':
                {
                    color: 'text.danger',
                },
            '.gigya-show-checkmark.gigya-valid': {
                backgroundImage: 'none',
            },
            '.gigya-show-validity-border.gigya-valid:not(.gigya-empty)': {
                borderColor: 'border.dark',
            },
            newUser: {
                textStyle: {base: 'head-small', sm: 'head-xsmall', md: 'head-small'},
                color: 'text.default',
                fontWeight: '500',
                marginBottom: {base: remCalc(8), sm: remCalc(16)},
            },
            registerNow: {
                textStyle: 'body-medium',
                color: 'text.default',
                marginBottom: {base: remCalc(16)},
            },
            '.gigya-spacer': {
                height: remCalc(24),
            },
            '.hr--solid:': {
                width: '100%',
                height: ' 1px',
                backgroundColor: 'border.light',
                margin: '24px 0',
            },
            '.dln-registrationForm__paragraph': {
                textStyle: 'body-small',
                color: 'text.default',
            },
            '.dlg-hidden': {
                display: 'none',
            },
            '.dln-completeForm__paragraph': {
                textStyle: 'body-xxsmall',
                lineHeight: '125%',
                width: ' 100%',
                color: 'text.default',
                margin: '0 0 16px',
            },
            '.dln-completeForm__paragraph--secondary': {
                textStyle: 'body-small',
                color: 'text.secondary',
                lineHeight: '125%',
                marginBottom: {base: remCalc(24), lg: remCalc(24)},
                display: 'inline-block',
            },
            '.dln-completeForm__paragraph--secondary:not(h2, label)': {
                display: 'flex',
                gap: remCalc(8),
                alignItems: 'center',
            },
            '.gigya-composite-control-checkbox .gigya-checkbox-text': {
                textStyle: 'body-small',
                fontWeight: '400',
                color: 'text.secondary',
                transition: 'color .12s linear',
            },
            '[data-screenset-element-id=gigya-update-profile-screen] .dln-registrationForm__paragraph.dln-registrationForm__paragraph--secondary':
                {
                    textStyle: 'head-medium',
                    fontWeight: 500,
                    margin: '24px 0',
                    textAlign: 'left',
                },
            '.dln-completeForm__paragraph a': {
                textDecoration: 'underline',
            },
            '.gigya-input-checkbox+label.gigya-label:before': {
                position: 'absolute',
                content: '""',
                display: 'block',
                width: remCalc(24),
                height: remCalc(24),
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.dark',
                backgroundColor: 'background.default',
                borderRadius: remCalc(2),
                top: '50%',
                left: 0,
                zIndex: 1,
                transform: 'translateY(-50%)',
            },
            '.gigya-input-checkbox+label.gigya-label:after': {
                position: 'absolute',
                display: 'none',
                content: '""',
                width: remCalc(7),
                height: remCalc(15),
                top: remCalc(3),
                left: remCalc(9),
                zIndex: 2,
                transform: 'rotate(45deg)',
                border: `${remCalc(1)} solid`,
                borderColor: 'border.dark',
                borderTop: 0,
                borderLeft: 0,
            },
            '.gigya-input-checkbox:checked+label.gigya-label:after': {
                display: 'block',
            },
            '.gigya-input-checkbox': {
                width: remCalc(24),
                height: remCalc(24),
                flexShrink: 0,
            },
            '[data-screenset-element-id=gigya-update-profile-screen] form .gigya-layout-row:nth-of-type(2), [data-screenset-element-id=gigya-update-profile-screen] form .gigya-layout-row:nth-of-type(3), [data-screenset-element-id=gigya-change-password-screen] form .gigya-layout-row':
                {
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                },
            '[data-screenset-element-id=gigya-update-profile-screen] form .gigya-layout-row:nth-of-type(2) .gigya-composite-control, [data-screenset-element-id=gigya-update-profile-screen] form .gigya-layout-row:nth-of-type(3) .gigya-composite-control, [data-screenset-element-id=gigya-change-password-screen] form .gigya-layout-row .gigya-composite-control':
                {
                    //marginBottom: remCalc(10),
                    w: {base: '100%', lg: '47%'},
                },
            '.gigya-composite-control-password .gigya-label': {
                marginLeft: remCalc(0),
            },
            '.gigya-layout-row:has(.gigya-layout-cell .gigya-composite-control-submit):has(.gigya-layout-cell .gigya-composite-control-link)':
                {
                    display: 'flex',
                    flexDirection: {base: 'column', lg: 'row'},
                    gap: remCalc(24),
                },
            '.gigya-layout-cell:not(.error-wrapper):has(input[type="submit"]), .gigya-layout-cell:not(.error-wrapper):has(a.dlgCancel)':
                {
                    maxW: {base: '100%', lg: remCalc(275)},
                    flex: 1,
                },
            '.error-wrapper': {
                maxWidth: '100%',
                display: 'flex',
                flexDirection: {base: 'column', lg: 'row'},
                gap: remCalc(24),

                '.gigya-composite-control-submit, .dlgCancel': {
                    maxW: {base: '100%', lg: remCalc(275)},
                    flex: 1,
                },
            },
            registrationTitle: {
                textStyle: 'body-large',
                color: 'text.default',
                margin: ' 0 0 8px',
                fontWeight: '500',
            },
            registrationSutitle: {
                textStyle: 'body-xsmall',
                color: 'text.default',
                margin: ' 0 0 20px',
            },
            registrationIcons: {
                boxSize: 'iconsSize.xlarge',
                margin: '0 40px 0 0',
                color: 'text.default',
            },
            registrationListItem: {
                alignItems: 'center',
                minHeight: remCalc(64),
                display: 'flex',
                width: '100%',
                borderBottom: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
            },
            registrationList: {
                margin: '0 0 40px',
                listStyle: 'none',
            },
            registrationListText: {
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                height: 'auto',
                padding: '21.5px 0',
                textStyle: 'body-small',
                color: 'text.secondary',
                gap: remCalc(4),
            },
            '[data-screenset-element-id=gigya-update-profile-screen] .gigya-login-spacer, [data-screenset-element-id=gigya-change-password-screen] .gigya-login-spacer':
                {
                    height: remCalc(1),
                    margin: {base: '30px 0', sm: '20px 0'},
                },
            '.gigya-social-login-container': {
                margin: '0 auto !important',
                width: 'auto !important',
            },
            '.gigya-login-providers-container': {
                width: 'auto !important',
            },
            '.gigya-social-login-container .gigya-login-provider-row': {
                marginBottom: remCalc(16),
            },
            '.gigya-social-login-container .gigya-login-provider-row .gigya-login-provider:not(:last-child)':
                {
                    marginRight: '16px !important',
                },
            '.gigya-composite-control-link, .dlgCancel': {
                display: 'block',
                maxW: '100%',
                width: '100%',
                outlineWidth: 0,
                textStyle: 'body-medium',
                fontWeight: 'bold',
                alignItems: 'center',
                padding: `${remCalc(10)} ${remCalc(24)} !important`,
                textAlign: 'center',
                maxHeight: remCalc(40),
                bg: 'button.background.secondary-default',
                color: 'button.text.secondary-default',
                border: remCalc(2),
                borderColor: 'button.border.secondary-default',
                borderStyle: 'solid',
                borderRadius: [
                    'button.radius.primary-default.base',
                    'button.radius.primary-default.sm',
                    'button.radius.primary-default.md',
                    'button.radius.primary-default.lg',
                ],
                _hover: {
                    border: 'none',
                    color: 'button.text.secondary-hover',
                    bg: 'button.background.secondary-hover',
                },
                _focus: {
                    borderColor: 'button.border.secondary-focused',
                    color: 'button.text.secondary-focused',
                    bg: 'button.background.secondary-focused',
                },
                _disabled: {
                    bg: 'button.background.secondary-disabled',
                    borderColor: 'button.border.secondary-disabled',
                    _hover: {
                        bg: 'button.background.secondary-disabled',
                        color: 'button.text.secondary-disabled',
                        border: remCalc(2),
                        borderColor: 'button.border.secondary-disabled',
                        borderStyle: 'solid',
                    },
                },
                _pressed: {
                    bg: 'button.background.secondary-pressed',
                    color: 'button.text.secondary-pressed',
                    borderColor: 'button.border.secondary-pressed',
                },
            },
            registrationFormStack: {
                width: {base: '100%', lg: 'calc(50% - 16px)'},
                margin: {base: 0, lg: '0 auto 0 0'},
            },
            clearFieldsContainer: {
                justifyContent: 'space-between',
                paddingBottom: remCalc(24),
            },
            paymentMethodsSubtitle: {
                marginTop: {base: remCalc(24), lg: remCalc(42)},
                marginBottom: remCalc(24),
                fontWeight: 500,
            },
            addCardButton: {
                w: {base: '100%', md: remCalc(332)},
            },
            deleteBlock: {
                display: 'flex',
                flexDirection: 'column',
                marginTop: remCalc(24),
                gap: remCalc(24),
            },
            deleteBlockText: {
                bg: 'background.light',
                textStyle: 'body-small',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                padding: remCalc(24),
            },
            confirmDeleteButton: {
                maxW: {base: '100%', lg: remCalc(275)},
            },
            storedCardsContainer: {
                marginBottom: remCalc(42),
                gap: remCalc(26),
                templateColumns: {
                    base: 'repeat(1, 1fr)',
                    lg: 'repeat(auto-fit, minmax(400px, 1fr))',
                },
            },
            feedbackContainer: {
                width: '100%',
            },
            cardContainer: {
                border: '1px solid #D4D4D4',
                borderRadius: 'medium.base',
                display: 'flex',
                flexDirection: 'column',
                gap: remCalc(24),
                w: '100%',
                maxW: remCalc(511),
                minW: {base: 'unset', lg: remCalc(400)},
            },
            brandContainer: {
                backgroundColor: 'background.light',
                paddingY: remCalc(16),
                paddingInline: remCalc(24),
                display: 'flex',
                justifyContent: 'space-between',
            },
            brandText: {
                marginLeft: remCalc(8),
            },
            infoContainer: {
                paddingInline: remCalc(24),
            },
            checkboxContainer: {
                paddingY: remCalc(16),
                paddingInline: remCalc(24),
            },
            infoNameContainer: {
                flexDirection: 'column',
                marginBottom: remCalc(8),
            },
            infoExpirationContainer: {
                flexDirection: 'column',
            },
            infoLabel: {
                color: 'text.secondary',
                textStyle: 'body-medium',
            },
            infoValue: {
                textStyle: 'body-medium',
            },
            checkboxLabel: {
                marginLeft: remCalc(8),
                textStyle: 'body-small',
                display: 'flex',
                alignItems: 'center',
            },
            modalContainer: {
                paddingBottom: remCalc(0),
            },
            modalHeader: {
                w: '100%',
                paddingY: remCalc(0),
            },
            modalHeaderContainer: {
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: remCalc(24),
                paddingBottom: remCalc(16),
                borderBottom: '1px solid black',
                w: '100%',
            },
            modalHeaderLabel: {
                fontWeight: 400,
                w: '100%',
            },
            modalBodyContainer: {
                paddingY: remCalc(24),
                w: '100%',
            },
            modalContentContainer: {
                w: '90%',
                maxW: remCalc(688),
                alignItems: 'center',
            },
            storedCardSkeleton: {
                h: remCalc(250),
                w: '100%',
                maxW: remCalc(511),
                marginBottom: remCalc(42),
            },
            formActionButtons: {
                flexDirection: {base: 'column-reverse', md: 'row'},
                backgroundColor: {base: 'background.default', md: 'unset'},
                width: '100%',
                gap: {base: remCalc(8), md: remCalc(16)},
                paddingTop: remCalc(16),
            },
            productRegButtonContainer: {
                width: '100%',
                height: 'auto',
                flexDir: 'row',
                alignItems: 'center',
                justifyContent: {
                    base: 'center',
                    sm: 'center',
                    md: 'center',
                    lg: 'flex-start',
                },
            },
            productRegButton: {
                width: '100%',
                maxWidth: remCalc(332),
                paddingY: remCalc(12),
                paddingX: 'small.base',
            },
            productRegModalContent: {
                maxWidth: remCalc(688),
                paddingX: {
                    base: 'small.base',
                    lg: 'none',
                },
                paddingY: {
                    base: 'medium.base',
                    lg: 'none',
                },
                marginX: {
                    base: 'small.base',
                    lg: '0px',
                },
            },
            productRegMoldaHeaderContent: {
                borderBottom: 'small',
                borderStyle: 'solid',
                justifyContent: 'space-between',
                pb: remCalc(16),
                fontWeight: 400,
            },
            productRegModalHeader: {
                p: 0,
            },
            productRegModalBody: {
                px: 0,
                py: remCalc(24),
            },
            productRegModalFooter: {
                p: 0,
            },
            productRegModalInnerFooter: {
                gap: remCalc(24),
                direction: 'column',
                align: 'center',
                w: '100%',
            },
        }
    },
    variants: {
        'profile-modal-buttons': {
            formActionButtons: {
                flexDirection: {base: 'column', md: 'row'},
                maxW: {base: '100%', md: remCalc(522)},
            },
            formActionButton: {
                width: {base: '100%', md: '50%'},
            },
        },
        'address-buttons': {
            formActionButtons: {
                flexDirection: {base: 'column', md: 'row'},
                maxWidth: {base: '100%', lg: remCalc(568)},
                gap: remCalc(22),
            },
            formActionButton: {
                width: {base: '100%', md: '50%'},
            },
        },
    },
}
